
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
export default {
  name: 'TutorialSegmentationSection',
  mixins: [eventTrackingMixins, lgmMixin],

  props: {
    data: {
      type: Object,
      default: () => ({
        // imagePath: undefined,
        // title: '咩人需要買自願醫保？',
        // buttonEnquiry: '查詢自願醫保',
        // buttonComparison: '比較自願醫保',
      }),
    },
  },

  data() {
    return {
      // imagePath: this.data?.imagePath || '~/assets/images/common/tenlife-normal-logo.png',
      // title: this.data?.Title || '[This is the Title]',
      // imageTextObj: this.data?.ImageText || {},
      // buttonEnquiry: this.data?.Button1Text || '...',
      // buttonComparison: this.data?.Button2Text || '...',
    }
  },
  
  methods: {

        
    handleClick(event) {
      event.preventDefault();

      const eventTrackingParams = this.handleEventTracking(event)
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)

      this.$goToURL(dataFromClickedElement.href, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId,
        injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
      });

    },
    
    handleEventTracking(event){
      event.preventDefault()
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement.href

      if (this.$isWhatsappLink(href)) {
        const eventTrackingParams = this.initEventTrackingParams()
        eventTrackingParams.a = 'open_whatsapp'
        eventTrackingParams.l =  ``
        eventTrackingParams.c = `guide_cta`
        this.sendEventTracking(eventTrackingParams)
        return eventTrackingParams
      }    

      return null
    },
  },
}
